module.exports = __webpack_public_path__ + "static/media/table_column_resize_large.faac9e9f.png";